'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _useStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _history = require('history');

var _constants = require('constants');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientConfig = window._hiration; /**
                                      * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
                                      */

var client;
var divId;
if (__DEVELOPMENT__) {
  var req = {};
  req['name'] = 'Edursdeka';
  req['target_url'] = _constants.TARGET_URL;
  client = new _ApiClient2.default(req);
  divId = 'content';
} else {
  var req = {};
  req['name'] = clientConfig.name;
  req['target_url'] = _constants.TARGET_URL;
  if (clientConfig.target_url) {
    req['target_url'] = clientConfig.target_url;
  }

  if (clientConfig.name == 'Edureka') {
    req['target_url'] = _constants.EDUREKA_URL;
  }
  client = new _ApiClient2.default(req);

  if (!clientConfig.div_content_id) {
    divId = 'content';
  } else {
    divId = clientConfig.div_content_id;
  }
}

var _browserHistory = (0, _useStandardScroll2.default)(function () {
  return _reactRouter.browserHistory;
})();
var dest = document.getElementById(divId);
var store = (0, _create2.default)(_browserHistory, client, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);

// export const COMPANY_NAME = 'Edurekfa';

// Set Company API Key as soon as project gets loaded.
var basename = '/app';
store.dispatch({ type: 'company/BASE_URL', key: '/app' });
if (__DEVELOPMENT__) {
  store.dispatch({ type: 'company/SET_API', key: 999 });
  store.dispatch({ type: 'company/SET_API', key: 123 });
  store.dispatch({ type: 'company/SET_GA', key: 'UA-98787165-1' });
  // store.dispatch({type: 'company/SET_TOKEN', key: "6991426_5ba37fb543525"});
  store.dispatch({ type: 'company/SET_TOKEN', key: false });
  store.dispatch({ type: 'company/SET_COMPANY', key: "Edurseka" });
  store.dispatch({ type: 'company/SHOW_DESIGN_LABEL', key: true });
  store.dispatch({ type: 'company/SHOW_CONTENT_LABEL', key: true });
  store.dispatch({ type: 'auth/SUBSCRIPTION_NEEDED', key: true });
  store.dispatch({ type: 'company/SHOW_FONT_PICKER', key: false });
  store.dispatch({ type: 'company/SHOW_COLOR_PICKER', key: true });
  store.dispatch({ type: 'company/SHOW_SPACING_PICKER', key: true });
  store.dispatch({ type: 'company/SHOW_CHARTS', key: true });
  store.dispatch({ type: 'company/SHOW_ZIP_RECRUITER', key: true });
  store.dispatch({ type: 'company/SSO_ENDPOINT', key: 'https://api-auth.edureka.co/sso/verify' });
  store.dispatch({ type: 'company/SSO_ENDPOINT', key: 'http://localhost:8000/dieu/sso' });
  store.dispatch({ type: 'company/BASE_URL', key: '/app' });
  store.dispatch({ type: 'company/USE_SSO_LOGIN', key: false });
  store.dispatch({ type: 'company/REDIRECT_URL', key: 'https://www.hiration.com' });
  store.dispatch({ type: 'company/TARGET_URL', key: 'http://localhost:8000/dieu' });
  store.dispatch({ type: 'company/BRAND_COLOR', key: '#1B1C1D' });
  store.dispatch({ type: 'company/BRAND_COLOR', key: undefined });
  store.dispatch({ type: 'company/BRAND_LOGO', key: false });
  store.dispatch({ type: 'company/SHOW_FREE_REVIEW', key: true });
  store.dispatch({ type: 'company/SHOW_ACCOUNT_DROPDOWN', key: true });
  store.dispatch({ type: 'company/SHOW_GET_PREMIUM', key: false });
  store.dispatch({ type: 'company/SHOW_GET_PREMIUM_IN_APP', key: true });
  store.dispatch({ type: 'company/SHOW_RESUME_REWRITE', key: true });
  store.dispatch({ type: 'company/BASIC_BUILDER', key: false });
  store.dispatch({ type: 'company/SHOW_TIMELINE', key: true });
  store.dispatch({ type: 'company/SHOW_ADD_NEW_SECTION', key: true });
  store.dispatch({ type: 'company/DIV_CONTENT_ID', key: divId });
  store.dispatch({ type: 'company/SHOW_RESUME_EDIT_LABEL', key: true });
  store.dispatch({ type: 'company/SHOW_TEXT_ANALYSIS_MENU', key: true });
  store.dispatch({ type: 'company/SHOW_MY_RESUMES', key: true });
  store.dispatch({ type: 'company/SHOW_IMAGE_UPLOAD', key: true });
  store.dispatch({ type: 'company/SHOW_SAVE_BUTTON', key: true });
  store.dispatch({ type: 'company/SHOW_COMMENT_BUTTON', key: true });
  store.dispatch({ type: 'company/RESUME_REVIEW', key: true });
  // store.dispatch({type: 'CHOOSE_DESIGN_TEMPLATE', id: 29, initialize: true});
  // store.dispatch({type: 'CHOOSE_CONTENT_TEMPLATE', id: 16, initialize: true});
  // store.dispatch({type: 'BASIC_BUILDER_PRINT_DESIGN', id: 27, initialize: true});
  store.dispatch({ type: 'templateData/SET_USER_NAME', id: 'Parth Choudhary', initialize: true });
  store.dispatch({ type: 'templateData/SET_USER_EMAIL', id: 'parth.choudhary@gmail.com', initialize: true });
  store.dispatch({ type: 'templateData/SET_USER_PHONE', id: '+91 7726864945', initialize: true });
  basename = '/app';
} else {
  console.log(clientConfig);
  store.dispatch({ type: 'company/SET_API', key: clientConfig.key });
  store.dispatch({ type: 'company/SET_GA', key: clientConfig.ga_code });
  store.dispatch({ type: 'company/SET_TOKEN', key: clientConfig.token });
  store.dispatch({ type: 'company/SET_COMPANY', key: clientConfig.name });
  store.dispatch({ type: 'company/SHOW_DESIGN_LABEL', key: clientConfig.show_design_label });
  store.dispatch({ type: 'company/SHOW_CONTENT_LABEL', key: clientConfig.show_content_label });
  store.dispatch({ type: 'auth/SUBSCRIPTION_NEEDED', key: clientConfig.subscription_needed });
  store.dispatch({ type: 'company/SHOW_FONT_PICKER', key: clientConfig.show_font_picker });
  store.dispatch({ type: 'company/SHOW_COLOR_PICKER', key: clientConfig.show_color_picker });
  store.dispatch({ type: 'company/SHOW_SPACING_PICKER', key: clientConfig.show_spacing_picker });
  store.dispatch({ type: 'company/SHOW_CHARTS', key: clientConfig.show_charts });
  store.dispatch({ type: 'company/SHOW_ZIP_RECRUITER', key: clientConfig.show_zip_recruiter });
  store.dispatch({ type: 'company/SHOW_TIMELINE', key: clientConfig.show_timeline });
  store.dispatch({ type: 'company/SHOW_ADD_NEW_SECTION', key: clientConfig.show_add_new_section });
  store.dispatch({ type: 'company/DIV_CONTENT_ID', key: divId });
  store.dispatch({ type: 'company/SHOW_RESUME_EDIT_LABEL', key: clientConfig.show_resume_edit_label });
  store.dispatch({ type: 'company/SHOW_TEXT_ANALYSIS_MENU', key: clientConfig.show_text_analysis_menu });
  store.dispatch({ type: 'company/SHOW_MY_RESUMES', key: clientConfig.show_my_resumes });
  store.dispatch({ type: 'company/SHOW_SAVE_BUTTON', key: clientConfig.show_save_button });
  store.dispatch({ type: 'company/SHOW_COMMENT_BUTTON', key: clientConfig.show_comment_button });
  store.dispatch({ type: 'company/IS_HIRATION', key: clientConfig.is_hiration });
  store.dispatch({ type: 'company/SHOW_IMAGE_UPLOAD', key: clientConfig.show_image_upload });
  if (clientConfig.name != 'Edureka') {
    store.dispatch({ type: 'company/SSO_ENDPOINT', key: clientConfig.sso_endpoint });
    store.dispatch({ type: 'company/USE_SSO_LOGIN', key: clientConfig.use_sso_login });
    store.dispatch({ type: 'company/REDIRECT_URL', key: clientConfig.redirect_url });
    if (clientConfig.target_url) {
      store.dispatch({ type: 'company/TARGET_URL', key: clientConfig.target_url });
    } else {
      store.dispatch({ type: 'company/TARGET_URL', key: _constants.TARGET_URL });
    }
    store.dispatch({ type: 'company/RESUME_REVIEW', key: clientConfig.resume_review });
    store.dispatch({ type: 'company/BRAND_COLOR', key: clientConfig.brand_color });
    store.dispatch({ type: 'company/BRAND_LOGO', key: clientConfig.brand_logo });
    store.dispatch({ type: 'company/SHOW_FREE_REVIEW', key: clientConfig.show_free_review });
    store.dispatch({ type: 'company/SHOW_ACCOUNT_DROPDOWN', key: clientConfig.show_account_dropdown });
    store.dispatch({ type: 'company/SHOW_GET_PREMIUM', key: clientConfig.show_get_premium });
    store.dispatch({ type: 'company/SHOW_GET_PREMIUM_IN_APP', key: clientConfig.show_get_premium_in_app });
    store.dispatch({ type: 'company/SHOW_RESUME_REWRITE', key: clientConfig.show_resume_rewrite });
    store.dispatch({ type: 'company/BASIC_BUILDER', key: clientConfig.basic_builder });
    if (clientConfig.basic_builder) {
      store.dispatch({ type: 'CHOOSE_DESIGN_TEMPLATE', id: clientConfig.design_template_id, initialize: true });
      store.dispatch({ type: 'CHOOSE_CONTENT_TEMPLATE', id: clientConfig.content_template_id, initialize: true });
      store.dispatch({ type: 'BASIC_BUILDER_PRINT_DESIGN', id: clientConfig.basic_builder_print_design_id, initialize: true });
      store.dispatch({ type: 'templateData/SET_USER_NAME', id: clientConfig.user_name, initialize: true });
      store.dispatch({ type: 'templateData/SET_USER_EMAIL', id: clientConfig.user_email, initialize: true });
      store.dispatch({ type: 'templateData/SET_USER_PHONE', id: clientConfig.user_phone, initialize: true });
    }
  }
  if (clientConfig.base_url || clientConfig.base_url_cl || clientConfig.base_url_pw) {
    if (divId == 'cover_letter') {
      store.dispatch({ type: 'company/BASE_URL', key: clientConfig.base_url_cl });
      basename = clientConfig.base_url_cl;
    } else if (divId == 'personal_website') {
      store.dispatch({ type: 'company/BASE_URL', key: clientConfig.base_url_pw });
      basename = clientConfig.base_url_pw;
    } else {
      store.dispatch({ type: 'company/BASE_URL', key: clientConfig.base_url });
      basename = clientConfig.base_url;
    }
  }
}

// function initSocket() {
//   const socket = io('', {path: '/ws'});
//   socket.on('news', (data) => {
//     console.log(data);
//     socket.emit('my other event', { my: 'data from client' });
//   });
//   socket.on('msg', (data) => {
//     console.log(data);
//   });
//
//   return socket;
// }

// global.socket = initSocket();


var component = _react2.default.createElement(
  _reactRouter.Router,
  { render: function render(props) {
      return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
          return !item.deferred;
        } }));
    }, history: (0, _history.useBasename)(function () {
      return _reactRouter.browserHistory;
    })({ basename: basename }) },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1729
// module chunks = 0